import ApplicationLogo from '@/Components/ApplicationLogo';
import { Link } from '@inertiajs/react';

export default function GuestLayout({ children, maxWidth = 'sm' }) {
    const maxWidthClasses = {
        sm: 'sm:max-w-md',
        md: 'sm:max-w-md',
        lg: 'sm:max-w-lg',
        xl: 'sm:max-w-xl',
        '2xl': 'sm:max-w-2xl',
        '3xl': 'sm:max-w-3xl',
        '4xl': 'sm:max-w-4xl',
        '5xl': 'sm:max-w-5xl',
        '6xl': 'sm:max-w-6xl',
        '7xl': 'sm:max-w-7xl',
        full: '',
    };
    
    const maxWidthClass = maxWidthClasses[maxWidth] || maxWidthClasses.sm;
    
    return (
        <div className="flex min-h-screen flex-col items-center bg-gray-100 pt-6 sm:justify-center sm:pt-0">
            <div>
                <Link href="/">
                    <ApplicationLogo className="h-20 w-40 fill-current text-gray-500" />
                </Link>
            </div>

            <div className={`mt-6 w-full overflow-hidden bg-white px-6 py-4 shadow-md sm:rounded-lg ${maxWidthClass}`}>
                {children}
            </div>
        </div>
    );
}
